var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task-delivery-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var isDelivering = ref.isDelivering;
    var isLoading = ref.isLoading;
    var deliverTask = ref.deliverTask;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var errorCode = ref.errorCode;
    var gotoTaskStep = ref.gotoTaskStep;
    var task = ref.task;
    var brandNetworks = ref.brandNetworks;
    var uploadContentUrl = ref.uploadContentUrl;
    var uploadedContentDeliveryUrl = ref.uploadedContentDeliveryUrl;
    var deleteUploadedContentUrl = ref.deleteUploadedContentUrl;
    var handleFileChange = ref.handleFileChange;
    var handleResetUploads = ref.handleResetUploads;
    var handleUploadFailed = ref.handleUploadFailed;
    var uploadHeaders = ref.uploadHeaders;
    var uploadedFiles = ref.uploadedFiles;
    var hasUploadedFiles = ref.hasUploadedFiles;
    var isFileUploading = ref.isFileUploading;
return [_c('task-delivery-view',{attrs:{"is-loading":isLoading,"is-delivering":isDelivering,"errors":errors,"error-message":errorMessage,"error-code":errorCode,"task":task,"brand-networks":brandNetworks,"upload-content-url":uploadContentUrl,"uploaded-content-delivery-url":uploadedContentDeliveryUrl,"delete-uploaded-content-url":deleteUploadedContentUrl,"upload-headers":uploadHeaders,"uploaded-files":uploadedFiles,"has-uploaded-files":hasUploadedFiles,"is-file-uploading":isFileUploading},on:{"file-change":handleFileChange,"reset-uploads":handleResetUploads,"upload-failed":handleUploadFailed,"deliver":deliverTask,"exit":gotoTaskStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }